export const REAL_NAME_VERIFIED = 1;
export const REAL_NAME_UNVERIFIED = 0;
export const REAL_NAME_STATUS = {
  [REAL_NAME_VERIFIED]: '已认证',
  [REAL_NAME_UNVERIFIED]: '未认证'
};

// 手机号 更新 权限
export const PHONE_UPDATE_ENABLE = 1;
